module.exports = __webpack_public_path__ + "static/04-546ef2120436a99cd4e475f5e4851c04.png";